import { datetimeSchema } from './datetime'
import { z } from 'zod'

export const userSchema = z.object({
  id: z.string().min(1),
  first_name: z.string().min(1),
  last_name: z.string().min(1),
})

export const commentObjectTypeSchema = z
  .enum(['monitor_alert'])
  .default('monitor_alert')

export const apiCommentSchema = z
  .object({
    id: z.string().min(1),
    text: z.string().min(1),
    user: userSchema,
    created_at: datetimeSchema,
    updated_at: datetimeSchema,
  })
  .transform((comment) => {
    const { created_at, updated_at, ...commentFields } = comment

    return {
      createdAt: created_at,
      updatedAt: updated_at,
      ...commentFields,
    }
  })

export type Comment = z.infer<typeof apiCommentSchema>
